// Theme hierarchy:
// Multi-vendor kiosk + Table QR  → Mall theme (set by mall admin)
// Vendor's own kiosk             → Vendor theme (set by vendor)
// Vendor's own stall QR          → Vendor theme (set by vendor)
// Admin dashboards               → Always dark (never affected by kiosk theme)

export function applyTheme(theme = 'dark', brandColor = null, bgColor = null, tileColor = null, fontColor = null, buttonTextColor = null, surfaceColor = null) {
  const root = document.documentElement;
  root.setAttribute('data-theme', theme);
  if (theme === 'brand' && brandColor) {
    root.style.setProperty('--accent', brandColor);
    root.style.setProperty('--brand-color', brandColor);
    root.style.setProperty('--accent-light', brandColor + '22');
  } else {
    root.style.removeProperty('--accent');
    root.style.removeProperty('--brand-color');
    root.style.removeProperty('--accent-light');
  }
  if (theme === 'brand' && bgColor) {
    root.style.setProperty('--bg', bgColor);
  } else {
    root.style.removeProperty('--bg');
  }
  if (theme === 'brand' && tileColor) {
    root.style.setProperty('--bg2', tileColor);
  } else {
    root.style.removeProperty('--bg2');
  }
  if (theme === 'brand' && fontColor) {
    root.style.setProperty('--text', fontColor);
  } else {
    root.style.removeProperty('--text');
  }
  if (theme === 'brand' && buttonTextColor) {
    root.style.setProperty('--button-text', buttonTextColor);
  } else {
    root.style.removeProperty('--button-text');
  }
  if (theme === 'brand' && surfaceColor) {
    root.style.setProperty('--bg3', surfaceColor);
  } else {
    root.style.removeProperty('--bg3');
  }
}
